import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Text = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #212121;
  margin-bottom: 20px;
`;

export const Card = styled(Box)`
  grid-area: 'board';
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 270px;
  height: 94px;
  background: #f5f5f5;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border-left: 10px solid;
  cursor: pointer;
`;

export const Div = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 20px;
  height: 100%;
  flex: 1 0 0;
  justify-content: flex-start;
  width: 100%;
  overflow-y: overlay;
  align-content: flex-start;
`;

export const Info = styled(Box)`
  width: 100%;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
  text-overflow: ellipsis;
`;

export const MembersLength = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #9e9e9e;
`;
